// extracted by mini-css-extract-plugin
export var bannerContentCustom = "ImageBannerWithContent-module--bannerContentCustom--a478a";
export var contentHeadingCustom = "ImageBannerWithContent-module--contentHeadingCustom--75405";
export var contentTextCustom = "ImageBannerWithContent-module--contentTextCustom--e942e";